(() => {
  const media = window.matchMedia('(max-width: 767px)');
  let queued = false;
  function measure() {
    queued = false;
    const host = document.querySelector('shopify-chat');
    if (!host) return;
    const root = host.shadowRoot;
    const button = root?.querySelector('[part~="activator"]') || root?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('[part~="activator"]');
    const focused = host.matches(':focus-within') || !!root?.activeElement || !!root?.querySelector('shopify-agent-runtime')?.shadowRoot?.activeElement;
    if (!button || !media.matches || focused || button.getAttribute('aria-expanded') === 'true') {
      host.classList.remove('hsbd-chat-clearance');
      return;
    }
    const r = button.getBoundingClientRect();
    const overlap = [...document.querySelectorAll('main a, main h1, main h2, main .price, main .hsbd-fabric-snapshot, main form p, main form h2, main form legend, main button, main input, main select, main textarea, main summary, main label, main details[open], .mini-cart button, .mini-cart label, #footer-wrapper h3, #footer-wrapper a, #footer-wrapper p, #footer-wrapper label, #footer-wrapper input, #footer-wrapper button, #bottom-footer')].some(el => {
      const closed = el.closest('details:not([open])');
      if (closed && !closed.querySelector(':scope > summary')?.contains(el)) return false;
      const b = el.getBoundingClientRect();
      const s = getComputedStyle(el);
      return b.width > 0 && b.height > 0 && s.visibility !== 'hidden' && s.display !== 'none' &&
        b.left < r.right + 8 && b.right > r.left - 8 && b.top < r.bottom + 8 && b.bottom > r.top - 8;
    });
    host.classList.toggle('hsbd-chat-clearance', overlap);
  }
  function schedule() {
    if (!queued) { queued = true; requestAnimationFrame(measure); }
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('click', schedule, true);
  document.addEventListener('focusin', schedule, true);
  document.addEventListener('focusout', schedule, true);
  media.addEventListener('change', schedule);
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'aria-expanded'] });
  let attempts = 0;
  function bindChat() {
    const root = document.querySelector('shopify-chat')?.shadowRoot;
    if (root) {
      observer.observe(root, { subtree: true, attributes: true, attributeFilter: ['aria-expanded'], childList: true });
      root.addEventListener('click', schedule, true);
      const inner = root.querySelector('shopify-agent-runtime')?.shadowRoot;
      if (inner) {
        observer.observe(inner, { subtree: true, attributes: true, attributeFilter: ['aria-expanded'], childList: true });
        inner.addEventListener('click', schedule, true);
      }
      schedule();
    } else if (++attempts < 20) { setTimeout(bindChat, 500); }
  }
  bindChat();
  schedule();
})();